<template>
  <div class="Products">

    <div v-if="list_products && list_products.length > 0" :class="(fixik>34) ? 'posFixedProducts' : ''">
      <!-- <div style="position: relative;">
        <div style="max-width: 274px;line-height: 26px;">
          {{ $t("results") }}:
          <span>
            <b>{{ list_products.length }}</b>
          </span>
        </div> -->
        <!-- <div style="margin-left: 30px;">
          <label>{{ $t("sortuj_po") }}</label>
          <select v-model="sortKey" @change="sortProducts">
            <option value="symbol">{{ $t("symbol") }}</option>
            <option value="netto_asc">{{ $t("cena_asc") }}</option>
            <option value="netto_desc">{{ $t("cena_dsc") }}</option>
          </select>

        <button @click="toggleSortOrder" style="margin: 0px;">
          {{ sortOrder === 'asc' ? '⬆️ ' + $t("rosnaco") : '⬇️ ' + $t("malejaco") }}
        </button>
        </div>
      </div> -->

      <!-- {{ comparisonList }} -->

      <div class="container_list_products" v-if="list_products">
        <Product
          v-for="product in sortedProducts"
          :key="product.id"
          :product="product"
          :zalogowany="zalogowany"
          :isInsidePoland="isInsidePoland"
        />
      </div>
    </div>

    <!-- <md-dialog :md-active.sync="showDialog" :md-backdrop="false" class="comparison-list">
      <div class="comparison-clear">
        <md-button class="md-primary closeDialogComparison" @click="clearComparionList">x</md-button>
      </div>
      <div style="height: 35px; margin-left: 15px;">
        <template v-for="index in comparisonList">
          <div :key="index" style="position: relative;  float: left;  margin: 0px 10px;">
            <button @click="removeItem(index)" style="position: absolute;  right: -5px;  top: -5px;  background: none;  border: none;  color: red;  cursor: pointer;">x</button>
            <img v-if="index" v-lazy="$url_img(index)" class="pic" style="width: 30px; max-height: 35px;"/>
          </div>
        </template>
      </div>
      <md-button v-if="Object.keys(comparisonList).length>1" class="md-manual" @click="comparisonProducts" style="">porównaj</md-button>
    </md-dialog> -->

    <!-- <md-dialog class="comparison" :md-active.sync="showDialogView">
      <div>
        <md-button class="md-primary closeDialogComparison" @click="clickDialogClose()" style="float:right">x</md-button>
      </div>
      <div style="padding: 10px;  max-height: 85%;  overflow-y: auto;">
        <h4 style="padding: 0px;  margin: 0px 18px;">Porównywane produkty</h4>
        <table v-if="Object.keys(parametrsProducts).length>0" class="tabComparison">

          <tr>
            <th style="width: 18%;"></th>
            <th :style="'width:'+(82/Object.keys(comparisonList).length)+'%'" v-for="comparison in comparisonList" :key="comparison">{{comparison}}</th>
          </tr>
          <tr v-for="param,indexParam in parametrsProducts.attributes" :key="indexParam">
            <td>{{param}}</td>
            <td v-for="comp, indexComp in comparisonList" :key="indexComp">
              <template v-if="parametrsProducts.data[indexComp] && parametrsProducts.data[indexComp] && parametrsProducts.data[indexComp][indexParam]">
                <div v-html="parametrsProducts.data[indexComp][indexParam].desc">
                </div>
              </template>
              <template v-else >
                <div style="text-align: center;">
                  -
                </div>
              </template>
            </td>
          </tr>

        </table>
      </div>
    </md-dialog> -->

    <DialogComparisons :showDialog="showDialogSelected" @clickDialogComparison="clickComparisonShow"/>
    <DialogComparisonView :showDialog="showDialogView" @clickDialogComparison="clickDialogClose"/>


    <div v-if="list_products && list_products.length == 0" class="info">
      {{ $t("empty_products") }}
    </div>
  </div>
</template>

<script>

const customLabels = {
  first: "<<",
  last: ">>",
  previous: "<",
  next: ">"
};

import { helpers } from "../mixins/helpers"
import { auth } from '../mixins/auth'
import { mapGetters } from "vuex"

import Product from "./Product"
import DialogComparisons from './Dialogs/DialogComparisons'
import DialogComparisonView from './Dialogs/DialogComparisonView'

export default {
  name: "ListProducts",
  mixins: [auth, helpers],
  props: ['fixik'],
  data() {
    return {
      pageOfItems: [], customLabels, perPage: 999, showDialogSelected: false, showDialogView: false, userCountry: '', isInsidePoland: false//, sortKey: 'symbol'
    };
  },
  components: {
    Product, DialogComparisons, DialogComparisonView
  },
  computed: {
    ...mapGetters('products', ["list_products","comparisonList","sortKey"]), // ,"comparisonList","parametrsProducts"]),
    comPerPage() {
      return this.perPage
    },
    sortedProducts() {
      return [...this.list_products].sort((a, b) => {
        let valA, valB
        let sortting

        if (this.sortKey === 'netto_asc' || this.sortKey === 'netto_desc') {
          valA = a['netto'];
          valB = b['netto'];
        } else {
          valA = a[this.sortKey];
          valB = b[this.sortKey];
        }
        // konwersja na liczby jeśli sortujemy po cenie
        if (this.sortKey === 'netto_asc' || this.sortKey === 'netto_desc') {
          if (this.sortKey === 'netto_asc') {
            sortting = 'asc'
          } else {
            sortting = 'desc'
          }
          valA = parseFloat(valA);
          valB = parseFloat(valB);
        } else {
          sortting = 'asc'
          valA = valA.toString().toLowerCase();
          valB = valB.toString().toLowerCase();
        }

        if (valA < valB) return sortting === 'asc' ? -1 : 1;
        if (valA > valB) return sortting === 'asc' ? 1 : -1;
        return 0;
      });
    }
  },
  watch: {
    comparisonList (newValue, oldValue) {
      if (newValue.length>0) {
        this.showDialogSelected = true
      } else {
        this.showDialogSelected = false
      }
    }
  },
  methods: {
    sortProducts() {
      // można dodać logikę dodatkową, np. zapamiętanie preferencji
    },
    // toggleSortOrder() {
    //   this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    // },
    onChangePage(pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems
    },
    onChange() {
      // update page of items
      // this.onChangePage();
    },
    clickDialogClose () {
      // this.$store.commit('products/SET_COMPARISON_PARAMETRS', [])
      // this.showDialogSelected = false
      this.showDialogView = false
    },
    clickComparisonShow (e) {
      // console.log(e)
      this.showDialogView = true
    }
  },
  created () {
    // https://api.myip.com/
    fetch("https://ipapi.co/json/")
      .then(res => res.json())
      .then(data => {
        this.userCountry = data.country; // np. "PL"
        this.isInsidePoland = data.country === "PL";
      })
      .catch(err => {
        console.error("Nie udało się nawiązać kontaktu:", err);
    });
  }
};
</script>

<style>
.vue-html2pdf .layout-container {
  position: relative !important;
  left: 0px !important;
  background: white !important;
}
.layout-container {
  width: 100% !important;
  height: 100% !important;
}
.tabComparison {
  width: 98%; margin: 1%;
}
.tabComparison tr th {
  padding: 4px 10px;
  color: black;
  background: #d2d2d2;
}
.tabComparison tr td {
  padding: 4px 10px;
  color:black;
}
.tabComparison tr:nth-child(even) {
  background: #F4F4F4
}
.tabComparison tr:nth-child(odd) {
  background: #FFF
}

/* .md-dialog {
  left: 185px;
  top: 95%;
}
.md-dialog-actions {
  min-height: 25px !important;
} */
/* .comparison {
  width: 98% !important;
  height: 98% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  top: 50% !important;
  left: 50% !important;
}
.comparison-list {
  top: 94% !important;
  left: 170px !important;
} */
.posFixedProducts {
  position: relative;
  top: 274px !important;
}

.lightbox {
  z-index: 999;
}
.lightbox__image img {
  max-width: 680px;
}
.lightbox__image {
  text-align: center;
}

.Products {
  text-align: left;
}
.container {
  list-style: none;
  margin: 0;
  padding: 0;
}
.float {
  max-width: 100%;
  margin: 0 auto;
}
.float:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.info {
  width: 100%;
  text-align: center;
  padding: 30px;
  color: red;
  text-transform: uppercase;
}
.flip-list-move {
  transition: transform 2s;
}

.pagination {
  margin: 0px;
  padding: 0px;
  display: block ruby;
  /* border: 1px solid red !important; */
  list-style: none;
  width: 100%;
}
.pagination-content {
  width: 100%;
  text-align: right;
  position: relative;
  right: 30px;
}

.pagination > li > a {
  position: relative;
  float: left;
  padding: 3px 5px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #337ab7;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
  cursor: pointer;
  font-size: 12px;
}
.pagination > li > a:hover {
  background-color: #f0f0f0;
  text-decoration: none;
}

.pagination > li.active {
  padding: 0px 0px;
  background-color: #fff;
}
ul.pagination li.page-item.page-number.active a.page-link {
  padding: 3px 5px !important;
  background-color: #448aff;
  color: white;
}

html.md-theme-default
  body
  div#app
  div.home
  div.content
  article.information
  div.Products
  div.pagination-content
  ul.pagination
  li.page-item.page-number.active
  a.page-link {
  padding: 10px;
}

.team-generator {
  max-width: 400px;
  margin: auto;
  text-align: center;
}
input {
  margin-bottom: 10px;
}
button {
  margin-bottom: 20px;
}
ul {
  list-style: none;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ListProducts.vue